export default "__VITE_ASSET__706f9445__"